import styled from 'styled-components';
import theme from 'theme';
import { Box, Typography } from 'components/ui';

export const AuthLayoutContainer = styled(Box)`
  display: flex;
  min-height: 100vh;
`;

export const AuthBrandingSection = styled(Box)`
  position: relative;
  display: none;
  width: 50%;
  overflow: hidden;
  background: linear-gradient(160deg, #1a5c42 0%, #2d7a5f 35%, #4f9b7b 70%, #3a8a6a 100%);
  animation: brandingReveal 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;

  @keyframes brandingReveal {
    from {
      opacity: 0;
      transform: translateX(-40px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (min-width: 1200px) {
    display: flex;
  }
`;

export const AuthBrandingContent = styled(Box)`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 40px;
  color: white;

  @media (min-width: 1536px) {
    padding: 56px;
  }
`;

export const AuthBrandingLogoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AuthBrandingHeroSection = styled(Box)`
  max-width: 620px;
`;

export const AuthBrandingHeadline = styled(Typography)`
  font-weight: 700;
  line-height: 1.15;
  font-size: ${theme.typography.fontSizeVeryBig}px;
`;

export const AuthBrandingDescription = styled(Typography)`
  margin-top: 24px;
  max-width: 480px;
  line-height: 1.7;
  color: ${theme.palette.primary.white};
`;

export const AuthBrandingFeatureList = styled(Box)`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AuthBrandingFeatureItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AuthBrandingFeatureIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${theme.palette.primary.main};
  flex-shrink: 0;
`;

export const AuthBrandingFeatureText = styled(Typography)`
  color: ${theme.palette.primary.white};
`;

export const AuthBrandingCopyright = styled(Typography)`
  color: ${theme.palette.primary.white};
`;

export const AuthFormSection = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background-color: ${theme.palette.primary.white};

  @media (min-width: 600px) {
    padding: 40px 48px;
  }

  @media (min-width: 1200px) {
    width: 50%;
    padding: 40px 48px;
  }
`;

export const AuthFormWrapper = styled(Box)`
  width: 100%;
  max-width: 460px;
`;

export const AuthMobileHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;

  @media (min-width: 1200px) {
    display: none;
  }
`;

export const AuthMobileLogoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AuthFormCard = styled(Box)`
  border-radius: 24px;
  background-color: ${theme.palette.background.paper};
  padding: 32px;
  box-shadow: 0 20px 60px ${theme.palette.custom.shadow};
  border: 1px solid ${theme.palette.custom.shadow};

  @media (min-width: 600px) {
    padding: 40px;
  }
`;

export const AuthDesktopLanguageSwitcher = styled(Box)`
  display: none;
  position: absolute;
  top: 24px;
  right: 24px;

  @media (min-width: 1200px) {
    display: flex;
  }
`;
